/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { ListAllPaddocksForOfflineQueryResponse, ListAllPaddocksForOfflinePathParams, ListAllPaddocksForOfflineQueryParams, ListAllPaddocksForOffline400, ListAllPaddocksForOffline401, ListAllPaddocksForOffline403, ListAllPaddocksForOffline404, ListAllPaddocksForOffline409, ListAllPaddocksForOffline500 } from "../../types/paddockController/ListAllPaddocksForOffline.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getListAllPaddocksForOfflineUrl(organizationId: ListAllPaddocksForOfflinePathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/paddocks/all` as const }
  return res
}

/**
 * @summary Full non-paginated paddock dataset for offline preparation (capped at 10 000)
 * {@link /api/organizations/:organizationId/paddocks/all}
 */
export async function listAllPaddocksForOffline(organizationId: ListAllPaddocksForOfflinePathParams["organizationId"], params?: ListAllPaddocksForOfflineQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListAllPaddocksForOfflineQueryResponse, ResponseErrorConfig<ListAllPaddocksForOffline400 | ListAllPaddocksForOffline401 | ListAllPaddocksForOffline403 | ListAllPaddocksForOffline404 | ListAllPaddocksForOffline409 | ListAllPaddocksForOffline500>, unknown>({ method : "GET", url : getListAllPaddocksForOfflineUrl(organizationId).url.toString(), params, ... requestConfig })
  return res.data
}